export default __webpack_public_path__ + "static/treneri-zdenek-rezler-deae92c1422a1ec5dd78eb578e98cf44.jpg";